import BottomHorizontalMenu from './BottomHorizontalMenu'

export default BottomHorizontalMenu
